import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'

import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Tooltip, Fade } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

//components of grids:
import ZonaTipoPartidas from './zona_tipopartidas';
import ZonaProductos from './zona_productos';
import ZonaProductosCaja from './zona_productos_caja';
import ZonaMaquinas from './zona_maquinas';
import ZonaActionButtons from './zona_action_buttons';

//actions:
import { navigate, setSaveState, openDialog } from '../../actions';
import { getZonaDetalles, modifyFieldDetalleZona } from '../../actions/zona_actions';
import { getCajasCentro } from '../../actions/cajas_centro_actions';
import { getTiposZona } from '../../actions/tipos_zona_actions';

import * as config from '../../constants/configuration';

const styles = theme => ({
    toolbar: {
        display: 'block',
        minHeight: 112,
        marginBottom: 15,
    },
    formControl: {
        margin: '5px 0 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    grid: {
        padding: '0 12px',
        width: '100%',
    },
    buttonAtras: {
        margin: '0 0 10px 16px',
        height: 40,
        width: 123,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
    buttonIcon: {
        marginLeft: theme.spacing(2),
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        height: 48
    },
});

class ZonaEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            descr: '', iTipoZona: 0, iCajaDestino: 0, elemCajaId: 0, elemNoCajaId: 0, recibeCobPag: false, activo: false
        };
    };

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getZonaDetalles(this.props.match.params.id);
        this.props.getTiposZona();

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.zonaDetalles !== this.props.zonaDetalles) {

            this.props.getCajasCentro(this.props.zonaDetalles.centroId);

            this.setState({
                centroId: this.props.zonaDetalles.centroId ? this.props.zonaDetalles.centroId : '',
                descr: this.props.zonaDetalles.descr ? this.props.zonaDetalles.descr : '',
                iTipoZona: this.props.zonaDetalles.iTipoZona ? this.props.zonaDetalles.iTipoZona : 0,
                iCajaDestino: this.props.zonaDetalles.iCajaDestino ? this.props.zonaDetalles.iCajaDestino : -1,
                elemCajaId: this.props.zonaDetalles.elemCajaId ? this.props.zonaDetalles.elemCajaId : 0,
                elemNoCajaId: this.props.zonaDetalles.elemNoCajaId ? this.props.zonaDetalles.elemNoCajaId : 0,
                // recibeCobPag: 0,
                activo: this.props.zonaDetalles.activo ? this.props.zonaDetalles.activo : false,
            });

        };

        if ((prevProps.updated !== this.props.updated) && this.props.updated) this.props.navigate("mae_zona");
    };

    //text field and boolean:
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };



    //tipo zona select:

    fillSelectOptionZonaList = () => {
        return this.props.tiposZona.map(tz => {

            return (
                <option key={tz.id} value={tz.id}>{tz.descr}</option>
            );

        });

    };

    handleChangeTipoZonaSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iTipoZona: value
        });
    };

    compareDescr = (a, b) => {
        if (a.descr < b.descr)
            return -1;
        if (a.descr > b.descr)
            return 1;
        return 0;
    }

    //caja destino select:
    fillSelectOptionCajaList = () => {
        return this.props.cajasCentro.map(cc => {

            return (
                <option key={cc.id} value={cc.id}>{cc.descr}</option>
            );

        });

    };

    handleCajaDestinoChangeSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iCajaDestino: value
        });
    };


    onBlur = (event, field) => {

        const value = this.state[field];

        if (this.props.zonaDetalles[field] !== value) {
            this.props.setSaveState(true);
            this.props.modifyFieldDetalleZona(field, value);
        }
    };


    onBlurCheckBox = (event, field) => {

        const value = event.target.checked;

        this.props.setSaveState(true);
        if (value === true) this.props.modifyFieldDetalleZona(field, 1);
        else if (value === false) this.props.modifyFieldDetalleZona(field, 0);
    };

    goBack = () => {
        if (this.props.saveState.pending) {
            this.props.openDialog('ConfirmationDialog', {
                message: 'Existen cambios no guardados. Desea abandonar la sección y perder los cambios?',
                acceptHandler: () => {
                    this.props.setSaveState(false);
                    this.props.navigate("mae_zona");
                }
            }, 'left-drawer-confirmation-message', false, 'sm');
        }
        else {
            this.props.navigate("mae_zona");
        }
    }



    render() {

        const { classes } = this.props;

        if (!this.props.zonaDetalles || !this.props.tiposZona) {

            return (<div></div>);

        }

        return (
            <div>
                <div className={classes.toolbar} />
                <Grid container spacing={24}>

                    <form>
                        {/* <Button className={classes.buttonAtras} variant="contained" color="secondary" onClick={() => this.props.navigate("mae_zona")}>Atrás</Button> */}
                        <IconButton className={classes.buttonIcon} variant="contained" color="secondary" onClick={this.goBack}> <Icon>keyboard_backspace</Icon></IconButton>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='descr'
                                    label='Descripción'
                                    placeholder='Descripción'
                                    autoFocus
                                    value={this.state.descr}
                                    onChange={(event) => this.handleValueChange(event, 'descr')}
                                    onBlur={(event) => this.onBlur(event, 'descr')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'descr') }; }}
                                />
                            </FormControl>


                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="iTipozona-placeholder">
                                    Tipo Zona
                                </InputLabel>
                                <Select
                                    native
                                    value={this.state.iTipoZona}
                                    onChange={(event) => this.handleChangeTipoZonaSelect(event, 'iTipoZona')}
                                    onBlur={(event) => this.onBlur(event, 'iTipoZona')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'iTipoZona') }; }}
                                >
                                    {this.fillSelectOptionZonaList()}
                                </Select>
                            </FormControl>
                        </div>
                        <div className={classes.containerPair}>
                            <Tooltip title="Caja en que se recojen los cobros de esta zona" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel htmlFor="iCajaDestino-placeholder">
                                        Caja Destino
                                    </InputLabel>
                                    <Select
                                        native
                                        value={this.state.iCajaDestino}
                                        onChange={(event) => this.handleCajaDestinoChangeSelect(event, 'iCajaDestino')}
                                        onBlur={(event) => this.onBlur(event, 'iCajaDestino')}
                                        onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'iCajaDestino') }; }}
                                    >
                                        {this.fillSelectOptionCajaList()}
                                    </Select>
                                </FormControl>
                            </Tooltip>

                            {/*
                            <FormControl className={classes.formControl}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!this.state.recibeCobPag ? 0 : 1}
                                            onChange={(event) => this.handleBooleanChange(event, 'recibeCobPag')}
                                            value='recibeCobPag'
                                        // onBlur={(event) => this.onBlurCheckBox(event, 'recibeCobPag')}
                                        // onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'recibeCobPag') }; }}
                                        />
                                    }
                                    label="¿Recibe cobros/pagos?"
                                />
                            </FormControl>*/}


                            <FormControl className={classes.formControl}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!this.state.activo ? 0 : 1}
                                            onChange={(event) => this.handleBooleanChange(event, 'activo')}
                                            onBlur={(event) => this.onBlurCheckBox(event, 'activo')}
                                            value='activo'
                                        // onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'activo') }; }}
                                        />
                                    }
                                    label="¿Activo?"
                                />
                            </FormControl>
                        </div>

                    </form>
                    <div className={classes.grid}>
                        <ZonaTipoPartidas />
                    </div>
                    <div className={classes.grid}>
                        <ZonaProductos />
                    </div>
                    {this.props.kd === undefined ?
                        (
                            <div className={classes.grid}>
                                <ZonaProductosCaja />
                            </div>
                        ) : (
                            ''
                        )}
                    {this.props.kd === undefined ?
                        (
                            <div className={classes.grid}>
                                <ZonaMaquinas />
                            </div>
                        ) : (
                            ''
                        )}
                    <div className={classes.grid}>
                        <ZonaActionButtons backHandler={this.goBack} />
                    </div>
                </Grid>

            </div >
        );

    };

};

ZonaEdit.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    zonaDetalles: PropTypes.object.isRequired,
    cajasCentro: PropTypes.array.isRequired,
    tiposZona: PropTypes.array.isRequired,
    updated: PropTypes.bool.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getZonaDetalles: PropTypes.func.isRequired,
    modifyFieldDetalleZona: PropTypes.func.isRequired,
    getCajasCentro: PropTypes.func.isRequired,
    getTiposZona: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        zonaDetalles: state.zonaDetalles.zona,
        cajasCentro: state.cajasCentro.cajasCentro,
        tiposZona: state.tiposZona.tiposzona,
        updated: state.zonaDetalles.updated,
        saveState: state.saveState,
        kd: state.userProfile.kd,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getZonaDetalles,
        modifyFieldDetalleZona,
        getCajasCentro,
        getTiposZona,
        setSaveState,
        openDialog
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(ZonaEdit)));
